import React from 'react';
import ReactDOM from 'react-dom';
import Page from './App';

ReactDOM.render(
  <Page />,
  document.getElementById('root')
);
